import { useMemo, type JSX } from 'react';
import { toast } from 'sonner';
import { ContactDetailsForm } from '@/components/ContactDetailsForm';
import { PageHeader } from '@/components/ui/page-header';
import { useMe, useUpdateMyContact } from '@/hooks/useMe';
import { contactDetailsOf } from '@/lib/contactDetails';

/** My details: how the team can reach this outreacher outside the portal. */
export function ProfilePage(): JSX.Element {
  const me = useMe();
  const update = useUpdateMyContact();
  const inviter = me.data?.role === 'outreacher' ? me.data.inviter : null;
  const value = useMemo(() => contactDetailsOf(inviter ?? {}), [inviter]);

  return (
    <div className="space-y-6">
      <PageHeader
        title="My details"
        description="How the team can reach you outside the portal. Only admins see these."
      />
      {inviter ? (
        <section aria-labelledby="contact-h" className="max-w-2xl space-y-3">
          <h2 id="contact-h" className="text-lg font-medium">
            Contact details
          </h2>
          <ContactDetailsForm
            value={value}
            pending={update.isPending}
            onSave={(patch) =>
              update.mutateAsync(patch).then(
                () => toast.success('Contact details saved'),
                (err: Error) => toast.error(`Couldn't save your contact details: ${err.message}`),
              )
            }
          />
        </section>
      ) : (
        <p className="text-sm text-muted-foreground">{me.isLoading ? 'Loading…' : "Couldn't load your details."}</p>
      )}
    </div>
  );
}
